/**
 * JSON-LD Schema 注入 Composable
 * 用於 GEO (Generative Engine Optimization) - 讓 AI 模型理解應用程式結構
 */

import { onMounted, onUnmounted } from 'vue'
import { getJsonLdString } from '../config/jsonld'

const JSON_LD_ID = 'bentana-jsonld-schema'

/**
 * 注入 JSON-LD Schema 到頁面 head
 * 這個 composable 會在組件掛載時自動注入 JSON-LD，卸載時自動移除
 */
export function useJsonLd() {
  let scriptElement: HTMLScriptElement | null = null

  /**
   * 注入 JSON-LD Schema
   */
  function injectJsonLd() {
    // 如果已存在，先移除（避免重複注入）
    const existing = document.getElementById(JSON_LD_ID) as HTMLScriptElement | null
    if (existing) {
      existing.remove()
    }

    // 創建新的 script 元素
    scriptElement = document.createElement('script')
    scriptElement.id = JSON_LD_ID
    scriptElement.type = 'application/ld+json'
    scriptElement.textContent = getJsonLdString()

    // 注入到 head（插入到最前面，確保優先被解析）
    document.head.insertBefore(scriptElement, document.head.firstChild)
  }

  /**
   * 移除 JSON-LD Schema
   */
  function removeJsonLd() {
    if (scriptElement) {
      scriptElement.remove()
      scriptElement = null
    } else {
      // 如果 scriptElement 引用丟失，通過 ID 查找並移除
      const existing = document.getElementById(JSON_LD_ID) as HTMLScriptElement | null
      if (existing) {
        existing.remove()
      }
    }
  }

  // 組件掛載時注入
  onMounted(() => {
    injectJsonLd()
  })

  // 組件卸載時移除（在 SPA 中通常不需要，但保持清潔是個好習慣）
  onUnmounted(() => {
    removeJsonLd()
  })

  return {
    injectJsonLd,
    removeJsonLd
  }
}

